import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/layout/Layout';

import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Builder from './pages/Builder';
import Workspace from './pages/Workspace';
import Tasks from './pages/Tasks';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Help from './pages/Help';

// Layout wrapper without authentication check
const AppLayout = () => {
    return <Layout><Outlet /></Layout>;
};

function App() {
    return (
        <AppProvider>
            <Router>
                <Routes>
                    {/* Public Landing Page */}
                    <Route path="/" element={<Landing />} />

                    {/* Main App Routes (Direct Access) */}
                    <Route path="/app" element={<AppLayout />}>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="builder" element={<Builder />} />
                        <Route path="workspace" element={<Workspace />} />
                        <Route path="tasks" element={<Tasks />} />
                        <Route path="analytics" element={<Analytics />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="help" element={<Help />} />

                        {/* Default redirect to dashboard */}
                        <Route index element={<Navigate to="dashboard" />} />
                    </Route>
                </Routes>
            </Router>
        </AppProvider>
    );
}

export default App;
